import { render, staticRenderFns } from "./TournamentShare.vue?vue&type=template&id=5ecc693c&scoped=true"
import script from "./TournamentShare.vue?vue&type=script&lang=js"
export * from "./TournamentShare.vue?vue&type=script&lang=js"
import style0 from "./TournamentShare.vue?vue&type=style&index=0&id=5ecc693c&prod&lang=scss&scoped=true"
import style1 from "./TournamentShare.vue?vue&type=style&index=1&id=5ecc693c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc693c",
  null
  
)

export default component.exports